<template>
	<div>
		<div class="content">
			<p class="text">主要情况表</p>
			<el-row type="flex" class="row-bg" justify="space-between">
				<el-form
					:model="queryParams"
					:rules="rules"
					ref="ruleForm"
					class="demo-ruleForm"
				>
					<el-col :span="24">
						<el-form-item label="技术领域" :required="true" label-width="18%">
							<div class="select_box_jishu flex flex-justify">
								<el-form-item prop="highTechApprovalOverheadBO.techFieldFirst">
									<el-select
										v-model="
											queryParams.highTechApprovalOverheadBO.techFieldFirst
										"
										@change="tecFieldCchange"
									>
										<el-option
											v-for="dict in tecFieldFirst"
											:key="dict.id"
											:label="dict.dictName"
											:value="dict.dictCode"
											placeholder="请选择"
										></el-option>
									</el-select>
								</el-form-item>

								<el-form-item prop="highTechApprovalOverheadBO.techFieldSecond">
									<el-select
										v-model="
											queryParams.highTechApprovalOverheadBO.techFieldSecond
										"
										@change="tecFieldSecondCchange"
									>
										<el-option
											v-for="dict in tecFieldSecond"
											:key="dict.id"
											:label="dict.dictName"
											:value="dict.dictCode"
											placeholder="请选择"
										></el-option>
									</el-select>
								</el-form-item>

								<el-form-item prop="highTechApprovalOverheadBO.techFieldThird">
									<el-select
										v-model="
											queryParams.highTechApprovalOverheadBO.techFieldThird
										"
									>
										<el-option
											v-for="dict in tecFieldThird"
											:key="dict.id"
											:label="dict.dictName"
											:value="dict.dictCode"
											placeholder="请选择"
										></el-option>
									</el-select>
								</el-form-item>
							</div>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<p>已获取的知识产权种类和数量(根据知识产权列表自动计算)</p>
					</el-col>
					<el-col :span="11">
						<el-form-item label="I类" prop="name" label-width="40%">
							<el-input
								type="number"
								:min="1"
								oninput="value=value.replace(/[^0-9.]/g,'')"
								v-model="queryParams.theOne"
								disabled
							></el-input>
						</el-form-item>
					</el-col>

					<el-col :span="11">
						<el-form-item label="II类" prop="name" label-width="40%">
							<el-input v-model="queryParams.theTwo" disabled></el-input>
						</el-form-item>
					</el-col>
					<el-col>
						<p>人力资源情况(根据人力盗源情况表自动计算)</p>
					</el-col>
					<el-col :span="11">
						<el-form-item label="职工总数" prop="name" label-width="40%">
							<el-input
								v-model="humanResourceCount1"
								placeholder="0"
								disabled
							></el-input>
						</el-form-item>
					</el-col>

					<el-col :span="11">
						<el-form-item label="科技人员数" prop="name" label-width="40%">
							<el-input
								v-model="humanResourceCount2"
								placeholder="0"
								disabled
							></el-input>
						</el-form-item>
					</el-col>

					<el-col :span="24">
						<p class="text">近三年销售收入 (万元)</p>
					</el-col>

					<el-col :span="24">
						<el-form-item label="" prop="name" label-width="18%">
							<div class="select_box flex flex-justify">
								<div>净资产</div>
								<div>销售收入</div>
								<div>利润总额</div>
							</div>
						</el-form-item>
						<el-form-item
							:label="lastThreeYears[0] + ''"
							prop="name"
							label-width="18%"
						>
							<div class="select_box">
								<el-input-number
									type="number"
									:max="99999999999999"
									:min="1"
									oninput="value=value.replace(/[^0-9.]/g,'')"
									placeholder="请输入"
									v-model="queryParams.thirdYear.netAsset"
								></el-input-number>
								<el-input-number
									type="number"
									:max="99999999999999"
									:min="1"
									oninput="value=value.replace(/[^0-9.]/g,'')"
									placeholder="请输入"
									v-model="queryParams.thirdYear.salesRevenue"
								></el-input-number>
								<el-input-number
									type="number"
									:max="99999999999999"
									:min="1"
									oninput="value=value.replace(/[^0-9.]/g,'')"
									placeholder="请输入"
									v-model="queryParams.thirdYear.totalProfit"
								></el-input-number>
							</div>
						</el-form-item>
						<el-form-item
							:label="lastThreeYears[1] + ''"
							prop="name"
							label-width="18%"
						>
							<div class="select_box">
								<el-input-number
									type="number"
									:max="99999999999999"
									:min="1"
									oninput="value=value.replace(/[^0-9.]/g,'')"
									placeholder="请输入"
									v-model="queryParams.secondYear.netAsset"
								></el-input-number>
								<el-input-number
									type="number"
									:max="99999999999999"
									:min="1"
									oninput="value=value.replace(/[^0-9.]/g,'')"
									placeholder="请输入"
									v-model="queryParams.secondYear.salesRevenue"
								></el-input-number>
								<el-input-number
									type="number"
									:max="99999999999999"
									:min="1"
									oninput="value=value.replace(/[^0-9.]/g,'')"
									placeholder="请输入"
									v-model="queryParams.secondYear.totalProfit"
								></el-input-number>
							</div>
						</el-form-item>
						<el-form-item
							:label="lastThreeYears[2] + ''"
							prop="name"
							label-width="18%"
						>
							<div class="select_box">
								<el-input-number
									type="number"
									:max="99999999999999"
									:min="1"
									oninput="value=value.replace(/[^0-9.]/g,'')"
									placeholder="请输入"
									v-model="queryParams.firstYear.netAsset"
								></el-input-number>
								<el-input-number
									type="number"
									:max="99999999999999"
									:min="1"
									oninput="value=value.replace(/[^0-9.]/g,'')"
									placeholder="请输入"
									v-model="queryParams.firstYear.salesRevenue"
								></el-input-number>
								<el-input-number
									type="number"
									:max="99999999999999"
									:min="1"
									oninput="value=value.replace(/[^0-9.]/g,'')"
									placeholder="请输入"
									v-model="queryParams.firstYear.totalProfit"
								></el-input-number>
							</div>
						</el-form-item>
					</el-col>

					<!-- <el-col>
            <p>近三年研究开发费用总额 (万元)</p>
        </el-col> -->

					<el-col :span="24">
						<el-form-item
							label="近三年研究开发费用总额 (万元) 此项系统根据研发开发活动情况表自动计算"
							prop="sumRDCost"
						>
							<el-input
								type="number"
								:min="1"
								oninput="value=value.replace(/[^0-9.]/g,'')"
								v-model="queryParams.sumRDCost"
								disabled
								placeholder="0"
							></el-input>
						</el-form-item>
					</el-col>

					<el-col :span="11" style="margin-right:20px;">
						<el-form-item
							label="其中:在中国境内研发费用总额(万元)"
							prop="highTechApprovalOverheadBO.expensesWithChina"
						>
							<el-input-number
								:max="99999999999999"
								type="number"
								:min="1"
								oninput="value=value.replace(/[^0-9.]/g,'')"
								v-model="
									queryParams.highTechApprovalOverheadBO.expensesWithChina
								"
								placeholder="0"
							></el-input-number>
						</el-form-item>
					</el-col>
					<el-col :span="11">
						<el-form-item label="其中：基础研究投入费用总额(万元)" prop="name">
							<el-input-number
								:max="99999999999999"
								type="number"
								:min="1"
								oninput="value=value.replace(/[^0-9.]/g,'')"
								v-model="
									queryParams.highTechApprovalOverheadBO
										.basicResearchInThePastThreeYears
								"
								placeholder="0"
							></el-input-number>
						</el-form-item>
					</el-col>
					<el-col :span="11" style="margin-right:20px;">
						<el-form-item
							label="近一年企业总收入(万元)"
							prop="highTechApprovalOverheadBO.totalRevenueInRecentYear"
						>
							<el-input-number
								:max="99999999999999"
								:min="1"
								oninput="value=value.replace(/[^0-9.]/g,'')"
								v-model="
									queryParams.highTechApprovalOverheadBO
										.totalRevenueInRecentYear
								"
								placeholder="0"
							></el-input-number>
						</el-form-item>
					</el-col>
					<el-col :span="11">
						<el-form-item
							label="近一年高新技术产品(服务)收入(万元)此项系统自动计算"
							prop="name"
						>
							<el-input-number
								:min="1"
								oninput="value=value.replace(/[^0-9.]/g,'')"
								v-model="queryParams.highTechProduct"
								placeholder="0"
								disabled
							></el-input-number>
						</el-form-item>
					</el-col>

					<el-col>
						<p>
							申请认定前一年是否发生重大安全、重大质量事故或严重环境违法行为。以被辖区工商、案件、质监、环境等行政管理部门给予处罚决定为依据。
						</p>
					</el-col>
					<el-col>
						<el-radio
							v-for="item in options"
							:key="item.value"
							:label="item.value"
							v-model="
								queryParams.highTechApprovalOverheadBO
									.isIllegalInThePreviousYear
							"
							>{{ item.label }}</el-radio
						>
					</el-col>
				</el-form>
			</el-row>
		</div>

		<el-row type="flex" justify="center" class="button_box">
			<el-col :span="6">
				<el-button type="primary" round @click="save(1)">保存</el-button>
			</el-col>
			<el-col :span="6">
				<el-tooltip class="item" effect="light" content="操作点击上方步骤导航栏可跳转至对应页面填写信息" placement="top">
					<el-button round @click="save(2)">下一步</el-button>
				</el-tooltip>
			</el-col>
		</el-row>
	</div>
</template>
<script>
import {
	getDict,
	queryDictDataByTypeAndCode,
	queryAdditionalInformation,
	saveAdditionalInformation
} from "@/api/ChinaHigh";
import { getLastThreeYears } from "@/api/specialization";
export default {
	data() {
		return {
			radio: 0,
			ruleForm: {
				name: ""
			},
			options: [
				{ label: "是", value: 1 },
				{ label: "否", value: 2 }
			],
			rules: {},
			humanResourceCount1: 0,
			humanResourceCount2: 0,
			queryParams: {
				highTechApprovalOverheadBO: {},
				theOne: 0,
				theTwo: 0,
				sumRDCost: 0,
				firstYear: {},
				secondYear: {},
				thirdYear: {},
				highTechProduct: 0,
				humanResourceCount: [0, 0],
				highTechApprovalAnnualSalesRevenueBOList: []
			},
			// 技术领域1
			tecFieldFirst: {},
			// 技术领域2
			tecFieldSecond: {},
			// 技术领域3
			tecFieldThird: {},
			lastThreeYears: [],
			rules: {
				"highTechApprovalOverheadBO.techFieldFirst": [
					{ required: true, message: "请选择技术领域", trigger: "change" }
				],
				"highTechApprovalOverheadBO.techFieldSecond": [
					{ required: true, message: "请选择技术领域", trigger: "change" }
				],
				"highTechApprovalOverheadBO.techFieldThird": [
					{ required: true, message: "请选择技术领域", trigger: "change" }
				]
			}
		};
	},
	created() {
		this.init();
	},
	methods: {
		save(status) {
			this.queryParams.firstYear.annual = this.lastThreeYears[2] + "";
			this.queryParams.secondYear.annual = this.lastThreeYears[1] + "";
			this.queryParams.thirdYear.annual = this.lastThreeYears[0] + "";
			this.queryParams.humanResourceCount = [];
			this.queryParams.theOne = parseInt(this.queryParams.theOne);
			this.queryParams.theTwo = parseInt(this.queryParams.theTwo);
			this.queryParams.sumRDCost = parseInt(this.queryParams.sumRDCost);
			this.queryParams.highTechApprovalOverheadBO.approvalId = this.$route.query.id;
			saveAdditionalInformation(this.queryParams).then(res => {
				if (res.code == "00000") {
					this.msgSuccess("操作成功");
					if (status === 2) {
						this.$emit("step", 10);
					}
				}
			});
		},
		init() {
			getLastThreeYears().then(res => {
				this.lastThreeYears = res.data;
			});

			// 技术领域1
			getDict({ type: "technical_field", parentId: 0 }).then(res => {
				this.tecFieldFirst = res.data;
			});
			queryAdditionalInformation(this.$route.query.id).then(res => {
				this.queryParams.theOne = res.data.theOne;
				this.queryParams.theTwo = res.data.theTwo;
				this.queryParams.firstYear =
					res.data.firstYear != null ? res.data.firstYear : {};
				this.queryParams.secondYear =
					res.data.secondYear != null ? res.data.secondYear : {};
				this.queryParams.thirdYear =
					res.data.thirdYear != null ? res.data.thirdYear : {};
				this.queryParams.highTechApprovalOverheadBO =
					res.data.highTechApprovalOverheadBO != null
						? res.data.highTechApprovalOverheadBO
						: {};
				this.queryParams.highTechProduct = res.data.highTechProduct;
				this.queryParams.humanResourceCount = res.data.humanResourceCount;
				this.humanResourceCount1 = res.data.humanResourceCount[0];
				this.humanResourceCount2 = res.data.humanResourceCount[1];
				this.queryParams.sumRDCost = res.data.sumRDCost;
				this.queryParams.highTechApprovalAnnualSalesRevenueBOList =
					res.data.highTechApprovalAnnualSalesRevenueBOList != null
						? res.data.highTechApprovalAnnualSalesRevenueBOList
						: [];
				console.log(res);
				if (
					res.data.highTechApprovalOverheadBO.techFieldFirst !== "" &&
					res.data.highTechApprovalOverheadBO.techFieldFirst !== null
				) {
					this.jishu(res.data.highTechApprovalOverheadBO.techFieldFirst, 1, 2);
				}
				if (
					res.data.highTechApprovalOverheadBO.techFieldSecond !== "" &&
					res.data.highTechApprovalOverheadBO.techFieldSecond !== null
				) {
					this.jishu(res.data.highTechApprovalOverheadBO.techFieldSecond, 2, 2);
				}
			});
		},
		tecFieldCchange(val) {
			this.jishu(val, 1, 1);
		},
		tecFieldSecondCchange(val) {
			this.jishu(val, 2, 1);
		},
		// 技术领域
		jishu(val, type, stauts) {
			queryDictDataByTypeAndCode({ code: val, type: "technical_field" }).then(
				res => {
					if (type == 1) {
						if (stauts == 1) {
							this.tecFieldThird = {};
							this.$set(
								this.queryParams.highTechApprovalOverheadBO,
								"techFieldSecond",
								""
							);
							this.$set(
								this.queryParams.highTechApprovalOverheadBO,
								"techFieldThird",
								""
							);
						}
						this.tecFieldSecond = res.data;
					} else {
						if (stauts == 1) {
							this.$set(
								this.queryParams.highTechApprovalOverheadBO,
								"techFieldThird",
								""
							);
						}
						this.tecFieldThird = res.data;
					}
				}
			);
		}
	}
};
</script>

<style scoped>
.flex .el-button {
	margin-bottom: 10px;
}
.button_box {
	margin-top: 20px;
}
.button_box button {
	padding: 10px 60px;
}
.image {
	width: 100%;
	height: auto;
}
.select_box {
	display: flex;
	justify-content: space-between;
}
.select_box .el-select,
.select_box .el-input,
.select_box > div {
	width: 30%;
}
.select_box_jishu .el-select,
.select_box_jishu .el-input,
.select_box_jishu > div {
	width: 90%;
}
.textarea {
	width: 90%;
	height: 164px;
	border: 1px solid #dcdfe6;
	border-radius: 4px;
	resize: none;
}

.wrap {
	width: 84%;
	margin-left: 16%;
}

.row-bg {
	width: 84%;
	margin: 0 auto;
	flex-wrap: wrap;
}

.content {
	margin-top: 30px;
	background: #fff;
	width: 100%;
	padding-bottom: 20px;
}
.content .text {
	font-size: 13px;
	border-bottom: 1px solid #d4d4d4;
	position: relative;
}
.content p {
	font-size: 13px;
	padding: 10px 20px;
}
.content .text::before {
	content: "";
	position: absolute;
	width: 4px;
	height: 18px;
	left: 10px;
	top: 10px;
	background: #7c99fd;
}
.el-table .cell {
	white-space: pre-line;
}
.el-select {
	width: 100%;
}
</style>
